// extracted by mini-css-extract-plugin
export default {"container":"styles_container__1dRtv","name":"styles_name__fXj8-"};